import { datadogRum } from '@datadog/browser-rum';
import { ENV, DD_SERVICE, DD_CLIENT_TOKEN } from './config';

export const errorsToIgnore: string[] = [
  'Warning: ',
  'updateNavigationLinks is not a function',
  'Invalid DOM property',
  '<ui-save-bar>',
  'Unexpected attributes on',
  'Fetch error POST https://browser-intake-datadoghq.com/',
  'browser-intake-datadoghq.com',
  'Error while getting checkout profile',
  'The shopify global is not defined',
  'Request failed with status code 401',
  'Uncaught "Script error."',
  'https://events.launchdarkly.com',
];

// Only initialize if we have the required config
if (DD_CLIENT_TOKEN && DD_SERVICE) {
  datadogRum.init({
    applicationId: 'a4876620-eb2d-42af-816d-3abec8d33cbf', // Same as parent app for unified tracking
    clientToken: DD_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: DD_SERVICE, // Use distinct service name like 'upsell-conditions' or 'upsell-flow-builder'
    env: ENV || 'development',
    sessionSampleRate: 100,
    // Session recordings use Microsoft Clarity instead of Datadog Session Replay.
    sessionReplaySampleRate: 0,
    startSessionReplayRecordingManually: true,
    trackUserInteractions: true,
    allowFallbackToLocalStorage: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [
      'https://development.app.reconvert.com/api',
      'https://development.app.reconvert.com/*',
      /https:\/\/development\.app\.reconvert\.com\/*/,
      'https://app.reconvert.com/api',
      'https://app.reconvert.com/*',
      /https:\/\/app\.reconvert\.com\/*/,
      /https:\/\/.*\.reconvert\.com\/api/,
      (url: string) => url.endsWith('reconvert.com'),
    ],
  });
}

export { datadogRum };
